var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { SiteSidebar } from '../entities/site-sidebar';
var cls = classNames('mobile-sidebar');
export var MobileSiteSidebarDefaultProps = {};
// -------- Styles -------->
var SidebarStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "]))),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
// -------- Components -------->
// TODO - bring this to the web package by default
var My = {
  Sidebar: styled(SiteSidebar)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), SidebarStyles)
};
export var MobileSiteSidebar = function (props) {
  var className = props.className;
  return React.createElement(My.Sidebar, {
    className: cls.name(className)
  });
};
MobileSiteSidebar.cls = cls;
MobileSiteSidebar.defaultProps = MobileSiteSidebarDefaultProps;
var templateObject_1, templateObject_2, templateObject_3;